import { createContext} from 'react';

export const ActiveFileDepartmentContext = createContext();